import type { FreelancerKVKInformationPageLocales } from '../types';

const freelancerKVKInformationPageLocales: FreelancerKVKInformationPageLocales =
  {
    checkKVKInformation:
      'Voor dit KVK nummer vonden we onderstaande gegevens, controleer deze goed.',
    companyDataSaved: 'Bedrijfsgegevens opgeslagen!',
    enterKVKNumberMessage:
      'Vul hieronder je KVK nummer in. Op basis van die informatie halen we andere gegevens van je bedrijf op.',
    errorBillingAddressEmpty:
      'Dit veld kan niet leeg zijn. Selecteer een factuuradres.',
    errorCompanyNameEmpty:
      'Dit veld kan niet leeg zijn. Selecteer een bedrijfsnaam voor facturatie',
    errorFetchingKVKInformation:
      'Er is iets fout gegaan bij het ophalen van de KVK informatie. Controleer of je het juiste KVK nummer hebt ingevuld.',
    errorKVKAlreadyExists:
      'Er is al een account gekoppeld aan dit kvk-nummer. Neem contact op met info@tadaah.nl als je geen toegang meer hebt tot dat account',
    errorKVKNumberEmpty:
      'KVK nummer kan niet leeg zijn. Je KVK nummer kan je vinden in correspondentie van de KVK',
    errorKVKNumberLength: 'KVK nummers zijn altijd {{length}} cijfers',
    errorTooManyRequests:
      'Je hebt te vaak geprobeerd de KVK gegevens op te halen. Probeer het over enkele minuten opnieuw.',
    fullName: 'Volledige naam',
    informationIncorrectInfo:
      'Wij krijgen deze informatie vanuit de KVK. Als je informatie niet klopt, neem dan contact op met de KVK.',
    isInformationIncorrect: 'Klopt je bedrijfsinformatie niet?',
    kvkInformationDialogdialogFirstInstruction: `Om als freelancer in de kinderopvang te kunnen werken moet je ingeschreven zijn bij de KVK en geregistreerd zijn met de werkzaamheden die jij zal verrichten (o.a. sbi -code 88.91.1en 86.91.3).
    Vul op de volgende pagina zo je KVK nummer in. Je gegevens worden dan automatisch opgehaald en ingevuld.
    Controleer deze gegevens. Kloppen je gegevens niet? Neem contact op met de KVK om je gegevens te wijzigen. Je KVK nummer staat op het bewijs van je inschrijving bij de KVK. Raadpleeg de KVK via de onderstaande link.`,
    kvkInformationIncomplete: `Één of meerdere van onderstaande velden zijn niet ingevuld, maar zijn wel vereist om de inschrijving te kunnen afronden. 
      Neem contact op met de KVK om deze gegevens toe te voegen of te corrigeren. Voor nu kan je deze stap overslaan.
      Je kunt dezegegevens later weer ophalen, als ze door de KVK zijn aangepast.`,
    kvkInformationSuccessfullyFetched:
      'De KVK informatie is succesvol opgehaald',
    kvkNumber: 'KVK nummer',
    refetchData: 'gegevens opnieuw ophalen',
    registrationAddress: 'Factuuradres',
    registrationAddressPlaceholder: 'Straatnaam, huisnummer, woonplaats',
    sbiCodes: 'SBI-code(s)',
    title: 'KVK Inschrijving',
    tradeName: 'Handelsnaam',
  };

export default freelancerKVKInformationPageLocales;
